<template>
  <div>
      <v-container grid-list-sm fluid>
        <v-row no-gutters>
          <v-col
            v-for="(file) in files"
            :sm="colsPerItem !== undefined ? colsPerItem : 2"
            xs="6"
            class="filesgrid-item pa-2"
            :key="'file-'+file.id"
          >
            <v-lazy
              style="width:100%; padding:0px; margin:0px;"
              :options="{threshold: .1}">
              <div>
                <v-img
                  :style="getStyleForImage(file)"
                  v-if="(file.filetype === 'jpg' || file.filetype === 'png' || file.filetype === 'jpeg' || file.filetype === 'pdf' || file.filetype === 'svg' || file.filetype === 'gif' || file.filetype === 'webp')"
                  :src="file.filetype !== 'svg' ? file.thumbnail256Url : file.rawUrl"
                  :lazy-src="file.filetype !== 'svg' ? file.thumbnail256Url : file.rawUrl"
                  @click="clickedItem(file)"
                  height=auto
                  max-width=250
                  v-on:load="loaded = true"
                  :aspect-ratio="file.filetype !== 'pdf' ? 1 : 0.6"
                >
                  <v-container
                    fill-height
                    fluid
                    class="filesgrid-item-container"
                  >
                    <v-row class="fill-height ma-0">
                      <v-col sm="12" flexbox class="text-center pa2">
                        <!--<span class="headline white--text" style="font-size:10px !important; line-height:unset !important;" v-text="file.name"></span>-->
                        <!-- <span class="headline white--text" style="font-size:10px !important; line-height:unset !important;" v-text="file.shopId"></span> -->
                      </v-col>
                    </v-row>
                    <div class="filesgrid-item-headline">
                      {{file.name}}
                      <!-- {{file.shopId}} -->
                    </div>
                    <div class="filesgrid-item-actions" v-if="actions.length > 0">
                      <div>
                        <span v-if="actions.includes('small')" class="filesgrid-item-action" icon @click.stop="selectFile(file.thumbnail64Url)" style="color:#606060;font-size:12px;">
                          XXS
                        </span>
                        <span v-if="actions.includes('small')" class="filesgrid-item-action" icon @click.stop="selectFile(file.thumbnail128Url)" style="color:#606060;font-size:12px;">
                          XS
                        </span>
                        <span v-if="actions.includes('small')" class="filesgrid-item-action" icon @click.stop="selectFile(file.thumbnail256Url)" style="color:#606060;font-size:12px;">
                          S
                        </span>
                        <span v-if="actions.includes('medium')" class="filesgrid-item-action" icon @click.stop="selectFile(file.thumbnail512Url)" style="color:#606060;font-size:12px;">
                          M
                        </span>
                        <span v-if="actions.includes('large')" class="filesgrid-item-action" icon @click.stop="selectFile(file.thumbnail1024Url)" style="color:#606060;font-size:12px;">
                          L
                        </span>
                      </div>
                      <div>
                        <v-tooltip bottom v-if="!shopId || shopId === 'avecor'">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span  class="filesgrid-item-action" icon @click.stop="deselectFileForAllShops(file)">
                                <v-icon size="13" :color="file.deselectedForShops ? '#C62828' : '#FFF'">fas fa-ban</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Poista näkyvistä webshopeilta.</span>
                        </v-tooltip>
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span  class="filesgrid-item-action" icon @click.stop="editFileName(file)">
                                <v-icon size="13" :color="'#FFF'">fas fa-pencil-alt</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Muokkaa nimeä. Nimi muodostaa kuvien järjestyksen.</span>
                        </v-tooltip>
                        
                        <!-- <span v-if="actions.includes('deselectForShop') && shopId !== 'avecor_website'" class="filesgrid-item-action" icon @click.stop="deselectFileForShop(file)">
                          <v-icon size="13" color="#606060">fas fa-ban</v-icon>
                        </span> -->
                        <!-- <span v-if="actions.includes('select')" class="filesgrid-item-action" icon @click.stop="selectFile(file)">
                          <v-icon size="13" color="#606060">far fa-check-square</v-icon>
                        </span> -->
                        <span v-if="actions.includes('delete')" icon @click.stop="removeFile(file)" class="filesgrid-item-action">
                          <v-icon size="13" color="#FFF">far fa-trash-alt</v-icon>
                        </span>
                        <span v-if="actions.includes('download')" icon @click.stop="downloadFile(file)" class="filesgrid-item-action">
                          <v-icon size="13" color="#FFF">fas fa-download</v-icon>
                        </span>
                        <span v-if="actions.includes('copyUrl')" icon @click.stop="copyToClipboard(file.rawUrl)" class="filesgrid-item-action">
                          <v-icon size="13" color="#FFF">far fa-clipboard</v-icon>
                        </span>
                      </div>
                    </div>  
                  </v-container>
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular v-show="!loaded || file.thumbnail128Url === ''" indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>
            </v-lazy>  
          </v-col>
        </v-row>
      </v-container>
        
      
      <v-dialog
        v-model="dialog"
        style="width:auto;"
        width="unset"
        v-if="selectedFile !== null"
      >
        <v-card :width="selectedSize" style="margin:0 auto;">
          <v-layout row wrap>
            <v-flex xs9 pl-2>
              <v-card-title  class="headline">
                <textarea style="width:100%; resize: none;" @change="fileNameChanged($event.target.value)" :value="filesMap[selectedFile.id] ? filesMap[selectedFile.id].name : ''" />
              </v-card-title>
            </v-flex>
            <v-flex v-if="selectedFile.filetype !== 'pdf'" xs3 pr-3 mt-3 style="text-align:right">
              <v-btn-toggle sizeMandatory=true style="border:1px #ccc solid;" v-model="selectedSize">
                <v-btn value="1024">
                  1024
                </v-btn>
                <v-btn style="border-left:1px #ccc solid;" value="512">
                  512
                </v-btn>
              </v-btn-toggle>
            </v-flex>
          </v-layout>
          <div v-if="selectedFile.filetype !== 'pdf' && selectedFile.filetype !== 'svg'">
            <div style="margin-left:20px">
              <span style="font-weight:bold">1024px</span><v-icon style="margin-left:5px; margin-right:20px;" @click="imagePrint(selectedFile.thumbnail1024Url);" size=18>fas fa-print</v-icon>
              <span style="font-weight:bold">512px</span><v-icon style="margin-left:5px" @click="imagePrint(selectedFile.thumbnail512Url);" size=18>fas fa-print</v-icon>
            </div>
            <v-img
              :width="selectedSize"
              :src="selectedSize == 1024 ? selectedFile.thumbnail1024Url : selectedFile.thumbnail512Url"
              :lazy-src="selectedFile.thumbnail128Url"
              v-on:load="diaglodImageLoaded = true"
            />
          </div>
          <div v-if="selectedFile.filetype === 'svg'">
            <v-img
              :width="selectedSize"
              :src="selectedFile.rawUrl"
              :lazy-src="selectedFile.rawUrl"
              v-on:load="diaglodImageLoaded = true"
            />
          </div>
          <div v-if="selectedFile.filetype === 'pdf'">
            <div style="margin-left:20px">
              <v-icon v-if="page > 1" @click.stop="page -= 1" size=18>far fa-arrow-alt-circle-left</v-icon>
              <v-icon v-if="page == 1" size=18 style="color:#aaa">far fa-arrow-alt-circle-left</v-icon>
              <v-icon v-if="page < numPages" style="margin-left:6px" @click.stop="page += 1;" size=18>far fa-arrow-alt-circle-right</v-icon>
              <v-icon v-if="page >= numPages" style="margin-left:6px; color:#aaa" size=18>far fa-arrow-alt-circle-right</v-icon>
              <!--<v-icon v-if="page == 1" size=14 syle="color:#aaa">far fa-arrow-alt-circle-left</v-icon>-->
              <v-icon style="margin-left:20px" @click="$refs.pdf.print(100, [page])" size=18>fas fa-print</v-icon>
              <input style="margin-left:20px; width: 2em;text-align:center" v-model.number="page" type="number" > /{{numPages}}
            </div>
            <pdf 
              ref="pdf"
              style="width:100%"
              @num-pages="numPages = $event"
              @link-clicked="page = $event"
              :page="page"
              :src="selectedFile.rawUrl">
            </pdf>
          </div>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import pdf from 'vue-pdf'
import firebase from 'firebase'
import axios from 'axios'
import { saveAs } from 'file-saver';
import download  from "downloadjs"

var db = null

/*
rules_version = '2';
service firebase.storage {
  match /b/{bucket}/o {
    match /{allPaths=**} {
      allow read, write: if request.auth != null;
    }
  }
}*/
/*
rules_version = '2';
service firebase.storage {
  match /b/{bucket}/o {
    match /{allPaths=**} {
      allow read, write;
    }
  }
}
*/

export default {
  
  props: ['types','actions','sharedDraftsOnly','sharedLogosOnly','product', 'productVariation', 
    'context', 'company', 'orderedProduct', 'order', 'numberOfItems', 'itemClick','filterCompanyId', 
    'filterProductId','colsPerItem', 'filterUserId', 'shopId'],
  components:{
    pdf
  },
  data: () => ({
    sizeMandatory:true,
    selectedSize:"512",
    selectedFile: null,
    filetype:"",
    dialog:false,
    pdfDialog:false,
    selectedFilelUrl:"",
    selectedFileName:"",
    searchTerm: '',
    miniVariant: true,
    miniVariantRight: true,
    right: true,
    rightDrawer: true,
    selectedFile: null,
    clipped: true,
    loaded:false,
    diaglodImageLoaded:false,
    numPages: 0,
    page: 1,
    files: [],
    drafts:[],
    productImages:[],
    logos:[],
    promotionImages:[],
    filesMap : {},
    logosMap : {},
    draftsMap: {},
    productImagesMap: {},
    informationFileMap:{},
    informationImagesMap:{},
  }),
  mounted() {
    db = firebase.firestore();
    this.updateFilesMap()
  },
  watch: {
    productVariation: function (val) {
      if(val === "") this.files = []
      else this.updateFilesMap()
    },
    company: function (val) {
      if(val === "") this.files = []
      else this.updateFilesMap()
    },
    orderedProduct: function (val) {
      if(val === "") this.files = []
      else this.updateFilesMap()
    },
    filterCompanyId:function (val) {
      this.createFilesArray()
    },
    filterProductId:function (val) {
      this.createFilesArray()
    }
  },
  computed: {
    ...mapFields([
      'settings',
      'user',
      'company.companies'
    ]),
  },
  created () {},
  methods: {
    getStyleForImage(file){
      var styles = 'cursor: pointer;'
      var border = 'border:1px solid #CCC;'
      var product = this.product
      var orderedProduct = this.orderedProduct
      var context = this.context
      if(((file.orderedProducts !== undefined && orderedProduct !== undefined && file.orderedProducts.includes(orderedProduct.id)) 
                    || (product !== undefined && product.selectedProductImageId !== undefined && file.id === product.selectedProductImageId ))
                    && (context !== 'promotion')) {
        border = 'border:1px solid #F36639;'
      }
      if((file.shopId === 'avecor' || !file.shopId)  && file.type === 'productImage') border = 'border:3px solid #F58F3A;'
      
      if(file.deselectedForShops) border = 'border:3px solid #C62828;'
      styles += border
      return styles              
    },
    deselectFileForAllShops(file){
      var deselected = true
      if(file.deselectedForShops) deselected = false
      db.collection('files').doc(file.id).set({
        deselectedForShops:deselected,
      }, { merge: true })
    },
    async editFileName(file){
      try{
        var name =  prompt("Tiedoston nimi", file.name);
        if(!name || name === '') {
          alert("Tyhjää tiedoston nimeä ei voi syöttää.")
          return
        }
        await db.collection('files').doc(file.id).set({
          name,
        }, { merge: true })
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      }
      catch(e){
        alert(e.message)
      }
    },
    createFilesArray() {
      var t = this
      //console.log("Product id"+ t.filterProductId)
      var drafts = Object.keys(this.draftsMap).reduce(function(result, fileId) {
        if(t.companies[t.draftsMap[fileId].companyId] === undefined) console.log(t.draftsMap[fileId])
        var companyShared =t.companies[t.draftsMap[fileId].companyId].sharedDrafts !== undefined && t.companies[t.draftsMap[fileId].companyId].sharedDrafts ? true : false
        var sharedDraftsOnly = t.sharedDraftsOnly !== undefined && t.sharedDraftsOnly ? true : false
        //if (t.draftsMap[fileId].companyId == "4QZ8LZgg2Ks5Cl0J1OyB") console.log(t.companies[t.draftsMap[fileId].companyId])
        
        if(t.filterUserId === undefined || t.filterUserId === '' || // NO FILTER
          (t.companies[t.draftsMap[fileId].companyId] !== undefined && (t.filterUserId === t.companies[t.draftsMap[fileId].companyId].salesperson || companyShared)) ) {
          //console.log({filterCompanyId:t.filterCompanyId,filterProductId:t.filterProductId,company:t.company})
          // BOTH COMPANY AND PRODUCT FILTERS SET
            
          if(sharedDraftsOnly && !companyShared){} // SKIP IF ONLY SHARED AND COMPANY NOT SHARED
          else {
            //if(t.draftsMap[fileId] === undefined) 
            if (t.filterCompanyId !== undefined && t.filterCompanyId !== '' && t.filterProductId !== undefined && t.filterProductId !== '') {
              //console.log("IN BOTH COMPANY AND PRODUCT FILTER SET")
              if(t.draftsMap[fileId].companyId === t.filterCompanyId && t.draftsMap[fileId].product === t.filterProductId) result.push({...t.draftsMap[fileId]});
            }
            // ONLY COMPANY FILTER SET
            else if (t.filterCompanyId !== undefined && t.filterCompanyId !== '') {
              //console.log("IN ONLY COMPANY FILTER SET")
              if(t.draftsMap[fileId].companyId === t.filterCompanyId) result.push({...t.draftsMap[fileId]});
            }
            // ONLY PRODUCT FILTER SET
            else if (t.filterProductId !== undefined && t.filterProductId !== '') {
              //console.log("IN ONLY PRODUCT FILTER SET")
              if(t.draftsMap[fileId].product === t.filterProductId) result.push({...t.draftsMap[fileId]});
            }
            // NO FILTER SET
            else if((t.filterCompanyId === undefined || t.filterCompanyId === '') && (t.filterProductId === undefined || t.filterProductId === '')) {
              result.push({...t.draftsMap[fileId]});
            }
          }
          
          
        }
        return result;
      }, []);
      var logos = Object.keys(this.logosMap).reduce(function(result, fileId) {
        if(t.companies[t.logosMap[fileId].companyId] === undefined) console.log(t.logosMap[fileId])
        var companyShared =t.companies[t.logosMap[fileId].companyId].sharedLogos !== undefined && t.companies[t.logosMap[fileId].companyId].sharedLogos ? true : false
        var sharedLogosOnly = t.sharedLogosOnly !== undefined && t.sharedLogosOnly ? true : false
        if(t.filterUserId === undefined || t.filterUserId === '' || 
          (t.companies[t.logosMap[fileId].companyId] !== undefined && (t.filterUserId === t.companies[t.logosMap[fileId].companyId].salesperson || companyShared)) ){
          if (sharedLogosOnly && !companyShared){} // SKIP IF ONLY SHARED AND COMPANY NOT SHARED
          else {
            if (t.filterCompanyId !== undefined && t.filterCompanyId !== '' && t.logosMap[fileId].companyId === t.filterCompanyId) {
              result.push({...t.logosMap[fileId]});
            }
            else if(t.filterCompanyId === undefined || t.filterCompanyId === '') {
              result.push({...t.logosMap[fileId]});
            }
          }
        }
        return result;
      }, []);
      var productImages = Object.keys(this.productImagesMap).reduce(function(result, fileId) {
        var file = t.productImagesMap[fileId]
        if (t.filterProductId !== undefined && t.filterProductId !== '' && file.productId === t.filterProductId) {
          result.push({...file});
        }
        else if(t.filterProductId === undefined || t.filterProductId === '') {
          if(t.shopId){
            // AVECOR WEBSITE
            if(t.shopId === 'avecor'){
              if(t.shopId === file.shopId || !file.shopId) result.push({...file});  
            }
            // WEBSHOPS
            else if(t.shopId !== 'avecor'){
              if(t.shopId === file.shopId) result.push({...file});  /* OWN SHOP FILES */
              else if (!file.deselectedForShops) result.push({...file}); /* SHARED FROM WEBSITE */ 
            }
          }
          else {
            result.push({...t.productImagesMap[fileId]});
          }
          
        }
        return result;
      }, []);
      
      var informationFiles = Object.keys(this.informationFileMap).reduce(function(result, fileId) {
          result.push({...t.informationFileMap[fileId]});
        return result;
      }, []);
      var informationImages = Object.keys(this.informationImagesMap).reduce(function(result, fileId) {
          result.push({...t.informationImagesMap[fileId]});
        return result;
      }, []);


      this.filesMap = {}
      this.filesMap = {...this.draftsMap, ...this.logosMap, ...this.productImagesMap, ...this.informationFileMap, ...this.informationImagesMap}
      var files = drafts.concat(logos).concat(productImages).concat(informationFiles).concat(informationImages)
      console.log("HERE")
      files = files.sort((a,b)=>{
        var aName = ''
        var bName = ''
        if(a.name) aName = a.name
        if(b.name) bName = b.name

        var nameA= aName.toLowerCase().trim(), nameB=bName.toLowerCase().trim();
        if (nameA > nameB) {return -1;}
        if (nameB > nameA) {return 1;}
        return 0;
      })
      /* var files = files.sort(function(a,b){
        var aDate = 1000
        var bDate = 1000
        if(a.created_at) aDate = a.created_at.seconds
        if(b.created_at) bDate = b.created_at.seconds
        return bDate - aDate;
      }); */
      this.files = files
    },
    updateFilesMap(){
      var t = this
      if(this.types !== undefined && this.types.includes("informationFile") ) {
        db.collection("files").where("type", "==", "informationFile")
        .onSnapshot(function(querySnapshot) {
            t.informationFileMap = {}
            querySnapshot.forEach(function(doc) {
                t.informationFileMap[doc.id] = {...doc.data()}
            });
            t.createFilesArray()
        })
      }
      if(this.types !== undefined && this.types.includes("signatureImage") ) {
        db.collection("files").where("type", "==", "signatureImage")
        .onSnapshot(function(querySnapshot) {
            t.informationFileMap = {}
            querySnapshot.forEach(function(doc) {
                t.informationFileMap[doc.id] = {...doc.data()}
            });
            t.createFilesArray()
        })
      }
      if(this.types !== undefined && this.types.includes("informationImages") ) {
        console.log("HERE")
        db.collection("files").where("type", "==", "informationImage")
        .onSnapshot(function(querySnapshot) {
            t.informationImagesMap = {}
            querySnapshot.forEach(function(doc) {
                t.informationImagesMap[doc.id] = {...doc.data()}
            });
            t.createFilesArray()
        })
      }
      if(this.types !== undefined && this.types.includes("draft") ) {
        if(this.company !== undefined && this.product !== undefined) {
          db.collection("files").where("companyId", "==", this.company.id).where("type", "==", "draft").where("product", "==", this.product.id)
          .onSnapshot(function(querySnapshot) {
              t.draftsMap = {}
              querySnapshot.forEach(function(doc) {
                  t.draftsMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
        else if(this.company === undefined && this.product !== undefined) {
          db.collection("files").where("type", "==", "draft").where("product", "==", this.product.id)
          .onSnapshot(function(querySnapshot) {
              t.draftsMap = {}
              querySnapshot.forEach(function(doc) {
                  t.draftsMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
        else if(this.company !== undefined && this.product === undefined) {
          db.collection("files").where("type", "==", "draft").where("companyId", "==", this.company.id)
          .onSnapshot(function(querySnapshot) {
              t.draftsMap = {}
              querySnapshot.forEach(function(doc) {
                  t.draftsMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
        else if (this.company === undefined && this.product === undefined) {
          db.collection("files").where("type", "==", "draft")
          .onSnapshot(function(querySnapshot) {
              t.draftsMap = {}
              querySnapshot.forEach(function(doc) {
                  t.draftsMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
      }
      if(this.types !== undefined && this.types.includes("logo") ) {
        
        if(this.company !== undefined && this.company !== "") {
          db.collection("files").where("companyId", "==", this.company.id).where("type", "==", "logo")//.where("products", "array-contains", this.productId)
          .onSnapshot(function(querySnapshot) {
              t.logosMap = {}
              querySnapshot.forEach(function(doc) {
                  t.logosMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
        else {
          db.collection("files").where("type", "==", "logo")
          .onSnapshot(function(querySnapshot) {
              t.logosMap = {}
              querySnapshot.forEach(function(doc) {
                  t.logosMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
      }
      if (this.types !== undefined && (this.types.includes("productImage"))){
        if(this.productVariation !== undefined && this.productVariation !== "") {
          // .where('myQUestion', whereIn: ['nameQuestion', 'ageQuestion'])
          db.collection("files").where("type", "in", ["productImage"]).where("productVariationId", "==", this.productVariation.id)
          .onSnapshot(function(querySnapshot) {
              t.productImagesMap = {}
              querySnapshot.forEach(function(doc) {
                  t.productImagesMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })

          /* db.collection("files").where("type", "==", "productImage").where("productVariationId", "==", this.productVariation.id)
          .onSnapshot(function(querySnapshot) {
              let productImagesMap = JSON.parse(JSON.stringify(this.shopsMap[this.selectedShopId].sections))
              t.productImagesMap = {}
              querySnapshot.forEach(function(doc) {
                  t.productImagesMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          }) */
        }
        else if(this.product !== '' &&  this.productVariation === "") {
          db.collection("files").where("type",  "in", ["productImage"]).where("productId", "==", this.product.id).where("productVariationId", "==", '')
          .onSnapshot(function(querySnapshot) {
              t.productImagesMap = {}
              querySnapshot.forEach(function(doc) {
                  t.productImagesMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
        else {
          db.collection("files").where("type",  "in", ["productImage"])
          .onSnapshot(function(querySnapshot) {
              t.productImagesMap = {}
              querySnapshot.forEach(function(doc) {
                  t.productImagesMap[doc.id] = {...doc.data()}
              });
              t.createFilesArray()
          })
        }
      }
      
      if (this.types !== undefined && this.types.includes("all")){
        db.collection("files")
        .onSnapshot(function(querySnapshot) {
            t.productImagesMap = {}
            querySnapshot.forEach(function(doc) {
                t.productImagesMap[doc.id] = {...doc.data()}
            });
            t.createFilesArray()
        })
      }
    },
    clickedItem(file){
      if(this.itemClick === 'select') {
        this.selectedFile = file;
        this.selectFile(file)
      } 
      else {
        this.selectedSize='512';
        this.dialog = true; 
        this.selectedFile = file;
      }
    },
    copyToClipboard (text) {
      this.$clipboard(text)
      this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kuvan URL kopioitu.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
    },
    imageSourcetoPrint(source){
      return "<html><head><style>@page { size: auto;  margin: 0mm 0mm 0mm 0mm; } .image {text-align:center;} body {margin:0px;}</style><script>function step1(){\n" +
				"setTimeout('step2()', 10); }\n" +  //
				"function step2(){window.print();window.close()}\n" +
				"</scri" + "pt></head><body onload='step1()'>\n" +
				"<div class='image'><img src='" + source + "' /></div></body></html>";
    },
    imagePrint(source) {
      var Pagelink = "about:blank";
      var pwa = window.open(Pagelink, "_new");
      pwa.document.open();
      pwa.document.write(this.imageSourcetoPrint(source));
      pwa.document.close();
    },
    selectFile(file){
      // RUN CUSTOM PARENT LEVEL FUNCTION
      if(this.context && this.context === 'promotion'){//
        var fileDetails = {id:file.id,url:file.thumbnail1024Url}
        this.$emit('selectedFile', fileDetails)
        return
      }
      if(this.context && this.context === 'information' && file.type === 'informationFile'){//
        var fileDetails = {...file}
        this.$emit('selectedFile', fileDetails)
        return
      }
      if(this.context && this.context === 'information' && this.types.includes('informationImages')){
        
        this.$emit('selectedFile', file)
        return
      }
      if(this.context && this.context === 'signatures' && this.types.includes('signatureImage')){
        this.$emit('selectedFile', file)
        return
      }
      
      // FOR ORDERED PRODUCTS (LOGO)
      if (file.type === "logo" && this.orderedProduct !== undefined){
        var currentLogoId = this.orderedProduct.selectedLogoId !== undefined ? this.orderedProduct.selectedLogoId : ""
        if(file.orders !== undefined && file.orders.includes(this.order.id)){
          currentLogoId !== "" ? db.collection('files').doc(currentLogoId).set({
            orderedProducts:firebase.firestore.FieldValue.arrayRemove(this.orderedProduct.id),
          }, { merge: true }) : ""
          db.collection('files').doc(file.id).set({
            orderedProducts:firebase.firestore.FieldValue.arrayUnion(this.orderedProduct.id),
          }, { merge: true })
        }
        else {
          currentLogoId !== "" ? db.collection('files').doc(currentLogoId).set({
            orderedProducts:firebase.firestore.FieldValue.arrayRemove(this.orderedProduct.id),
            orders:firebase.firestore.FieldValue.arrayRemove(this.order.id),
          }, { merge: true }) : ""
          db.collection('files').doc(file.id).set({
            orderedProducts:firebase.firestore.FieldValue.arrayUnion(this.orderedProduct.id),
            orders:firebase.firestore.FieldValue.arrayUnion(this.order.id),
          }, { merge: true })
        }
        this.$store.dispatch('orderedProduct/set', {
          id:this.orderedProduct.id,
          selectedLogoId:file.id
        })
        return 
      } 

      // FOR PRODUCTS (PRODUCT IMAGE)
      else if (file.type === "productImage" && this.product !== undefined){
        console.log("HERE2")
        this.$store.dispatch('product/set', {
          id:this.product.id,
          selectedProductImageId:file.id,
          selectedProductImage1024Url:file.thumbnail1024Url,
          selectedProductImage512Url:file.thumbnail512Url,
          selectedProductImage256Url:file.thumbnail256Url,
          selectedProductImage128Url:file.thumbnail128Url
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Valittu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      }

      // FOR ORDERED PRODUCTS (DRAFTS) 
      else if (file.type === "draft" && this.orderedProduct !== undefined){
        var currentDraftId = this.orderedProduct.selectedDraftId !== undefined ? this.orderedProduct.selectedDraftId : ""
        if(file.orders !== undefined && file.orders.includes(this.order.id)){
          currentDraftId !== "" ? db.collection('files').doc(currentDraftId).set({
            orderedProducts:firebase.firestore.FieldValue.arrayRemove(this.orderedProduct.id),
          }, { merge: true }) : ""
          db.collection('files').doc(file.id).set({
            orderedProducts:firebase.firestore.FieldValue.arrayUnion(this.orderedProduct.id),
          }, { merge: true })
        }
        else {
          currentDraftId !== "" ? db.collection('files').doc(currentDraftId).set({
            orderedProducts:firebase.firestore.FieldValue.arrayRemove(this.orderedProduct.id),
            orders:firebase.firestore.FieldValue.arrayRemove(this.order.id),
          }, { merge: true }) : ""
          db.collection('files').doc(file.id).set({
            orderedProducts:firebase.firestore.FieldValue.arrayUnion(this.orderedProduct.id),
            orders:firebase.firestore.FieldValue.arrayUnion(this.order.id),
          }, { merge: true })
        }
        this.$store.dispatch('orderedProduct/set', {
          id:this.orderedProduct.id,
          selectedDraftId:file.id
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      }
    },
    downloadFile(file){
      var x=new XMLHttpRequest();
      x.open( "GET", file.rawUrl , true);
      x.responseType="blob";
      x.onload= function(e){download(e.target.response, file.name+"."+file.filetype);};
      x.send();
    },
    async removeFile(file){
      if (confirm('Haluatko varmasti poistaa kuvan?')) {
        try{
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Poistetaan...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
          //var url = this.settings.dev ? 'http://api-test.avecor.fi:5000/avecor-709ff/us-central1/deleteFile': 'https://us-central1-avecor-709ff.cloudfunctions.net/deleteFile'
          var url = this.settings.dev ? 'http://localhost:5000/avecor-709ff/us-central1/deleteFile': 'https://us-central1-avecor-709ff.cloudfunctions.net/deleteFile'
          
          console.log("HERE")
          var token = await firebase.auth().currentUser.getIdToken()
          
          axios.defaults.headers.common['Authorization'] = "Bearer " +token;
          await axios.get(url, {
            headers: {
              'fileid': file.id,
            },
            crossdomain: true
          })
          
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Poistettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:6000, snackText:e.message, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
          console.log(e.message)
        }
      }
    },
    fileNameChanged(name){
      name !== undefined && name !== "" ? db.collection('files').doc(this.selectedFile.id).set({
        name
      }, { merge: true }) : alert("Tiedostolle määriteltävä joku nimi.")
    }

    
  }
}
</script>


<style>
  .filesgrid-item {
    position:relative;
  }
  .filesgrid-item-actions2 {
    display:none;
    position:absolute;
    width:40px;
    top:6px;
    right:97px;
    z-index: 10;
    background:#000;
    border-bottom-left-radius: 5px;
    border-top-left-radius: 5px;
  }
  .filesgrid-item-headline {
    display:none;
    z-index: 10;
    color:#FFF;
    background: #000;
    padding: 2px 5px 2px 5px;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    text-align: center;
    font-size:10px;
  }
  .filesgrid-item-actions {
    display:none;
    z-index: 10;
    background: #000;
    padding: 4px 5px 4px 5px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    text-align: center;
  }
  .filesgrid-item-action{
    padding:2px;
    
  }

  .filesgrid-item-actions:hover {
    display:block;
  }
  .filesgrid-item .filesgrid-item-container:hover .filesgrid-item-actions, .filesgrid-item .filesgrid-item-container:hover .filesgrid-item-headline{
    display:block;
  }
  .filesgrid-item .headline{
    display:none;
    font-size:10px;
  }

  .filesgrid-item:hover .headline{
    display:block;
    background: #000;
    font-size:10px;
  }

  .filesgrid-item .filesgrid-item-container:hover .v-image {
    border:1px solid #F36639;
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/MediaGrid.vue